export const Country = {
  MEX: 'MEX',
  COL: 'COL',
  PER: 'PER',
  CHL: 'CHL',
  ARG: 'ARG',
} as const;

export const Theme = {
  LIGHT: 'light',
  DARK: 'dark',
} as const;

export type ICountry = (typeof Country)[keyof typeof Country];
export type ITheme = (typeof Theme)[keyof typeof Theme];
